import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SOTProductViewModel } from '../../models';
import { SOTService } from '../../services';

@Component({
  selector: 'sot-properties',
  templateUrl: "./properties.component.html",
  styleUrls: ["./properties.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Properties implements OnInit, OnDestroy {
  @Input() product: SOTProductViewModel;

  public groups: { langkey: string, header?: string, open: boolean, properties: string[] }[];

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
    console.debug("--- sot-properties constructor")
  }

  ngOnInit() {
    console.debug("--- sot-properties ngOnInit")
    const me = this;
    me.groups = [];
    if (me.product) {
      if (me._sotService.GetSettings().use_co2) {
        const co2 = me.product.details.co2;
        if (co2 > 0) {
          me.groups.push({ "langkey": "details_co2", open: false, "properties": [me._sotService.formatCurrency(co2, false, true) + "g"] });
        }
      }
      if (me._sotService.GetSettings().use_nutrition_values) {
        const nutritions = me.product.details.nutritions;
        if (nutritions.nutritionItemViewModels.length > 0) {
          me.groups.push({ "langkey": "details_nutritions", "header": nutritions.header, open: false, "properties": nutritions.nutritionItemViewModels.map((item) => item.title + ": " + item.value) });
        }
      }
      if (me._sotService.GetSettings().use_allergens) {
        const allergens = me.product.details.allergens;
        if (allergens.length > 0) {
          me.groups.push({ "langkey": "details_allergens", open: false, "properties": allergens });
        }
      }
      if (me._sotService.GetSettings().use_additives) {
        const additives = me.product.details.additives;
        if (additives.length > 0) {
          me.groups.push({ "langkey": "details_additives", open: false, "properties": additives });
        }
      }
      if (me._sotService.GetSettings().use_eCommerce) {
        if (me.product.details.item_Content.length > 0) {
          const content = me.product.details.item_Content;
          me.groups.push({ "langkey": "details_ingredients", open: false, "properties": [content] });
        }
        if (me.product.details.hasProvider_Info) {
          const providerName = me.product.details.item_Provider_Name;
          const providderAddr = me.product.details.item_Provider_Addr;
          me.groups.push({ "langkey": "details_distributor", open: false, "properties": [providerName, providderAddr] });
        }
      }
    } else {
      me._sotService.coreLogService.error("Properties.ngOnInit", "no product");
    }
    me.PushChanges();
  }

  ngOnDestroy() {
    console.debug("--- sot-properties ngOnDestroy")
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("Properties.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public toggleAccordian(group: { langkey: string, open: boolean, properties: string[] }): void {
    group.open = !group.open;
    this.PushChanges();
  }

}